/**
 * Copyright 2021 Ginih (https://www.ginih.com)
 * Created By Marlon
 * Coded by Ginih Team
 **/

import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// react plugin for creating charts
// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icon
// core components
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import dashboardStyle from "../../assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import {withRouter} from "react-router-dom";
import {withTranslation} from "react-i18next";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../components/TabPanel/TabPanel";


class Automations extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
        };
    }


    handleChange = (event, newValue) => {
        this.setState({ value: newValue });
    };

    handleChangeIndex = (index) => {
        this.setState({ value: index });
    };

    a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };




    render() {
        const { classes, t } = this.props;
        const { value } = this.state;

        return (
            <div>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <AppBar position={"static"} className={classes.tabBar}>
                            <Tabs value={value} onChange={this.handleChange} aria-label="tab">
                                <Tab label={t('AUTOMATIONS_TEXT')} {...this.a11yProps(0)} />
                                <Tab label={t('EXECUTIONS_TEXT')} {...this.a11yProps(1)} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={value} index={0}>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                        </TabPanel>
                    </GridItem>
                </GridContainer>
            </div>
        );
    }
}

Automations.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(dashboardStyle)(withTranslation()(Automations)));